'use strict';

import {Model} from 'backbone';
import SingleBuyingOptionCollection from './SingleBuyingOptionCollection';

export default class SingleBuyingOptionsRegionModel extends Model {
  get idAttribute() {
    return 'inventoryRegion';
  }

  /**
   * Override set so that can ensure the collection class is used.
   *
   * @param {object} attributes
   * @param {Backbone.ModelSetOptions} [options]
   * @returns {SingleBuyingOptionsRegionModel}
   */
  set(attributes, options) {
    if (attributes.buyingOptions && !(attributes.buyingOptions instanceof SingleBuyingOptionCollection)) {
      attributes.buyingOptions = new SingleBuyingOptionCollection(attributes.buyingOptions);
    }
    return super.set(attributes, options);
  }

  defaults() {
    return {
      inventoryRegion: null,
      title: null,
      productIsDiscontinued: false,
      buyingOptions: [],
      orderIncrement: null,
      orderMinimumQuantity: null,
      showFreeShipping: false
    }
  }

  toJSON() {
    let json = super.toJSON();
    json.buyingOptions = json.buyingOptions.toJSON();
    return json;
  }
}



// WEBPACK FOOTER //
// ./assets/components/SingleBuyingOptions/SingleBuyingOptionsRegionModel.js